import { Component } from '@angular/core';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';
import { CmPageHistoryService } from '../../services/page-history.service';

@Component({
    selector: 'cm-not-found',
    templateUrl: './cm-not-found.component.html',
    styleUrls: ['./cm-not-found.component.scss'],
    standalone: false
})
export class CmNotFoundComponent {
	readonly locFeature: PortalCoreFeature;

	constructor(private pageHistory: CmPageHistoryService, private settings: CmSettingsService) {
		this.locFeature = this.settings.portalCoreFeature;
	}

	goBack() {
		this.pageHistory.back();
	}
}
